/* eslint-disable no-unused-vars */
/**
 * Import 3rd party packages
 */

/**
 * Import modules / classes
 */
import Menu from "./modules/Menu";
import MenuMobile from "./modules/MenuMobile";
import ActiveteAOS from "./modules/ActiveteAOS";
import ScrollHeader from "./modules/ScrollHeader";
import GdprPenaltiesSwitcher from "./modules/gdprPenaltiesSwitcher";
import GdprAccordion from "./modules/gdprAccordion";
import GdprTableLoad from "./modules/gdprTableLoad";
import GdprMobileFilters from "./modules/gdprMobileFilters";
import Select2 from "./modules/Select2";

/**
 * Instantiate a new object using imported modules/classes
 */
document.addEventListener("DOMContentLoaded", () => {
    const menu = new Menu();
    const menuMobile = new MenuMobile();
    const activateAos = new ActiveteAOS();
    const scrollHeader = new ScrollHeader();
    const gdprPenaltiesSwitcher = new GdprPenaltiesSwitcher();
    const gdprAccordion = new GdprAccordion();
    const gdprTableLoad = new GdprTableLoad();
    const gdprMobileFilters = new GdprMobileFilters();
    const select2 = new Select2();
});
